import React, { Fragment } from 'react'

import Img from 'gatsby-image'

import HeaderPage from '../components/header/headerpage'
import Footer from '../components/footer/footer'
import ModuloRicerca from '../components/homepage/moduloricerca'
import WhyUs from '../components/homepage/whyus'
import Evidenza from '../components/homepage/evidenza'
import Testimonial from '../components/homepage/testimonial'


const IndexPage = (props) => {
    
    return (
        <Fragment>

            <HeaderPage />
            <div style={{ height: '60px' }} />


            <div className="uk-section uk-section-muted uk-flex uk-flex-center uk-flex-middle uk-text-center uk-inline" data-uk-height-viewport="offset-top: true; offset-bottom: true" style={{
                backgroundColor: "grey"
            }} >

                <div className="uk-light uk-position-small uk-position-bottom-right">
                    <p>Foto di <a href="">Walter Nobile</a></p>
                </div>

                <Img
                    sizes={props.data.headerImage.sizes}
                    style={{
                        top: 0,
                        left: 0,
                        position: 'absolute',
                        objectFit: 'cover',
                        height: '100%',
                        width: '100%'
                    }}
                    imgStyle={{
                        objectPosition: 'center top',
                    }}
                />

            </div>

            <ModuloRicerca titolo="Trova il miglior fotografo o videografo professionista della tua zona" placeh="Seleziona la tua zona" bak="white" />

           <WhyUs foto={props.data.whyUs.sizes} />

           <Evidenza />

           <Testimonial foto={props.data.testImage.sizes} />

           <ModuloRicerca titolo="Non rischiare! Trova il tuo professionista, adesso!" placeh="Seleziona la tua zona" bak="white" />

            <Footer user={{name: 'Prowedding', partitaIva: '02987940737'}}/>

            

        </Fragment>
    )
}

export default IndexPage

export const pageQuery = graphql`
  query HeaderImageQuery {
    headerImage: imageSharp(id: { regex: "/hero/" }) {
      sizes(maxWidth: 1920 ) {
        ...GatsbyImageSharpSizes
      }
    },
    testImage: imageSharp(id: { regex: "/testimonial/" }) {
        sizes(maxWidth: 1920 ) {
          ...GatsbyImageSharpSizes
        }
      },
      whyUs: imageSharp(id: { regex: "/whyus/" }) {
        sizes(maxWidth: 1920 ) {
          ...GatsbyImageSharpSizes
        }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js